<template>
  <div class="text-left">
    <h3>{{ newRecord && newRecord.id ? 'Обновить запись в черном списке' : 'Добавить запись в черный список' }}</h3>
    <form v-if="newRecord" action="" @submit="addToList">
      <div class="form-group">
        <label for="">Номер телефона</label>
        <input :disabled="!!newRecord.id" v-model="newRecord.phone_num" placeholder="+7 915 000 00 00"
               class="form-control" type="text" required>
      </div>
      <div class="pb-2 card mb-1" v-if="newRecord.comments">
        <div class="card-header"><h6>Записи</h6></div>
        <div class="card-body">
          <div class="comment" v-for="(comment, index) in newRecord.comments" :key="`comment_${index}`">
            <p>{{ comment.text }}</p>
            <template v-if="comment.drugs && comment.drugs.length">
              <hr>
              <p v-for="drug in comment.drugs">{{ drug.title }}</p>
            </template>
            <p class="author">{{ comment.user_name }}: {{ comment.created_at }}</p>
          </div>
        </div>
      </div>
      <div class="p-2" v-if="newRecord.id">
        <div class="form-group">
          <input type="checkbox" id="ch_1" v-model="newRecord.is_active">
          <label class="pl-2 pointer" for="ch_1">Запись активна, информация отображается в заявках</label>
        </div>
      </div>
      <div class="form-group">
        <label for="">Комментарий</label>
        <textarea v-model="newRecord.comment" class="form-control" :required="!newRecord.id" placeholder="Комментарий"
                  rows="3"></textarea>
      </div>
      <div class="form-group">
        <label for="">Добавить препараты</label>
        <div v-if="drugsSelected && drugsSelected.length">
          <template v-for="drug, index in drugsSelected">
            <div class="flex justify-content-between mb-1" v-if="drug">
              {{ drug.title }}
              <button type="button" @click="removeDrug(index)" class="btn btn-sm btn-warning">Х</button>
            </div>
          </template>
        </div>
        <DrugSearchNew
          ref="drugSelect"
          :onDrugSelect="onDrugSelect"/>
      </div>
      <div class="text-right">
        <vue-ladda type="submit" button-class="btn btn-primary"
                   data-style="zoom-in"
                   :loading="saveLoading">Сохранить
        </vue-ladda>
        <button @click="onCancel" type="button" class="ladda-button btn btn-default">Отмена</button>
      </div>
    </form>
  </div>
</template>

<script>

import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import DrugSearchNew from "@/components/drugs/DrugSearchNew";

export default {
  props: ['newRecord', 'onCancel', 'updateRecordList', 'blackListPhoneNum'],
  components: {
    VueLadda,
    DrugSearchNew,
  },
  data() {
    return {
      localRecord: null,
      saveLoading: false,
      drugsSelected: [],
    }
  },
  async mounted() {
    console.log('mounted');
    if (this.blackListPhoneNum) {
      await this.getBlackListData();
    }
  },
  methods: {
    async getBlackListData() {

    },
    removeDrug(index) {
      delete this.drugsSelected[index];
      this.drugsSelected = [...this.drugsSelected];
    },
    onDrugSelect(e) {
      this.drugsSelected.push({id: e.id, title: e.title});
      this.$refs.drugSelect.drug = null;
    },
    async addToList(e) {
      e.preventDefault();
      this.saveLoading = true;
      if (this.drugsSelected && this.drugsSelected.length) {
        this.newRecord.drugs = [...this.drugsSelected];
      }
      if (!this.newRecord.id) {
        this.newRecord.is_active = 1;
      }
      const result = await this.updateRecord(this.newRecord);
      if (result.success) {
        this.Toast.fire({
          type: 'success',
          title: 'Сохранено'
        });
        if (this.updateRecordList) {
          this.updateRecordList(result.record);
        }
        this.onCancel();
      } else {
        this.Toast.fire({
          type: 'warning',
          title: result.message || 'Ошибка сервера'
        });
      }
      this.saveLoading = false;
    },
    async updateRecord(record) {
      const {data} = await api.post('/clients/blacklist', {
        ...record,
        type: 'update',
      });
      return data;
    },
  }
}

</script>

<style scoped>
.comment {
  border-bottom: 1px solid lightgray;
  background-color: #f4f4f4;
  padding: 2px;
  margin-bottom: 10px;
}

hr {
  margin: 3px 0;
}

.comment p {
  margin-bottom: 0;
}

.comment .author {
  text-align: right;
  font-size: 12px;
}
</style>
